export default function CloseMe() {
  return (
    <div className="bg-indigo-950 min-h-screen flex flex-col items-center justify-center">
      {/* Header */}
      <div>
        <img src={"./logo.png"} alt="Logo" className="w-40 h-40 rounded-xl" />
      </div>
      <div className="mb-8 mt-4">
        <h1 className="text-5xl text-blue-300">CozyIntros</h1>
      </div>

      <div className="space-y-4">
        <p className="text-xl text-blue-100">
          Nice job! You can close this tab and we'll be in touch via email within a few hours.
        </p>
        <p className="text-xl text-blue-100">To reach us in the meantime, email <a className="text-blue-400 underline" href="mailto:contact@cozyintros.com">contact@cozyintros.com</a>.</p>
        <p className="text-xl text-blue-100">The Power of the Network - Stay Cozy!</p>
      </div>
    </div>
  );
}
